// extracted by css-extract-rspack-plugin
export default {"container":"G_wyeGj3tw8svhfX","scroll":"ov_2XHFrfUu7PpFf","cast":"FCxttknNnpkDP3bN","top":"pIhQtzHCfAEJC7Ma","bottom":"LrFRPXS1s9phFquG"};